import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './App.css';
import pksLogo from "./images/pks-logotip.png";
import pksLogoCyr from "./images/pks-logotip-cyr.png";
import upitnikDoc from "./documents/upitnik-djordje-vajfert-2022.docx"
import pksFooterLogo from "./images/footer-logo.png";
import pksFooterLogoCyr from "./images/footer-logo-cyr.png";
import pozivnoPismo from "./documents/pozivno-pismo-DOP.pdf";
import rokoviDoc from "./documents/rokovi-djordje-vajfert-2022.pdf"
import smerniceDoc from "./documents/smernice-za-pripremu-projekta.pdf";
import metodologijaDoc from "./documents/metodologija-dodele-nagrade.pdf"
import primeriDobrePrakseDoc from "./documents/primeri-dobre-prakse.pdf"
import pravilnikOdodeliDoc from "./documents/pravilnik-o-dodeli-nagrade.pdf"
import { HiOutlineDocumentText } from 'react-icons/hi';
import { HiPhoneOutgoing } from 'react-icons/hi';
import { HiMail } from 'react-icons/hi';
import { BsPhone } from 'react-icons/bs';


function App() {
  const { i18n, t } = useTranslation()
  const [company, setCompany] = useState("")
  const [contact_person, setContact_person] = useState("")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [contact_person_position, setContact_person_position] = useState("")
  const [mb, setMb] = useState("")
  const [questionare, setQuestionare] = useState(null)
  const [files, setFiles] = useState([])
  const [isAgreed1, setIsAgreed1] = useState(false)
  const [isAgreed2, setIsAgreed2] = useState(false)
  const [isAgreed1Error, setIsAgreed1Error] = useState(false)
  const [isAgreed2Error, setIsAgreed2Error] = useState(false)
  const [isSendingInProgres, setIsSendingInProgres] = useState(false)
  const [validationErrors, setValidationErrors] = useState({})
  const [isSentSuccessful, setIsSendSuccessful] = useState(false)

  const changeLocales = () => {
    i18n.language === "lat" ? i18n.changeLanguage("cyr") : i18n.changeLanguage("lat")
  }

  const checkUpitnikSize = (file) => {
    if (file > 15728640) {
      alert(`${t("fajlSize15mb")}`);
    } else {
      setQuestionare(file)
    }
  };

  const checkOstalaDokumentaOgranicenja = (files) => {
    const outputFiles = []
    if (files.length > 4) {
      alert(`${t("brFajlovaOgranicenje")}`);
    } else {
      for (let i = 0; i < files.length; i++) {
        if (files[i] > 15728640) {
          alert(`${t("fajlSize15mb")}`);
        } else {
          outputFiles.push(files[i])
        }
      }
      setFiles(outputFiles)
    }

  }

  const sendForm = () => {
    setIsSendingInProgres(true)

    const formData = new FormData();


    formData.append('company', company);
    formData.append('contact_person', contact_person);
    formData.append('email', email);
    formData.append('phone', phone);
    formData.append('contact_person_position', contact_person_position);
    formData.append('mb', mb);
    formData.append('questionare', questionare);
    // let filesToSend = new Array()
    for (let i = 0; i < files.length; i++) {
      formData.append('files[]', files[i]);
    }
    // fetch("https://pks.ohdstaging.com/public-api/nacionalna-nagrada", {
    fetch("https://api.pks.rs/public-api/nacionalna-nagrada", {

      method: 'POST',
      headers: {
        "Accept": 'application/json',
      },
      body: formData,
    }).then((res) => res.json())
      .then((result) => {
        if (result.errors) {
          setValidationErrors(result.errors)
        } else {
          setIsSendSuccessful(true)
        }
        setIsSendingInProgres(false)
      }).catch((error) => {
        setIsSendingInProgres(false)
      });

  }

  const checkSendingForm = () => {
    if (isAgreed1) {
      setIsAgreed1Error(false)
    } else {
      setIsAgreed1Error(true)
    }
    if (isAgreed2) {
      setIsAgreed2Error(false)
    } else {
      setIsAgreed2Error(true)
    }

    if (isAgreed1 && isAgreed2) {
      sendForm()
    }
  }
  return (
    <>
      <header>
        <a className="logo-link" href="https://pks.rs/" target="_blank" rel="noopener noreferrer">
          {i18n.language === "lat" &&
            <img className="header-logo" src={pksLogo} alt="logo" />
          }
          {i18n.language === "cyr" &&
            <img className="header-logo" src={pksLogoCyr} alt="logo" />
          }
        </a>
        <div className="locales-btn-wrapper" onClick={() => changeLocales()}>{i18n.language === "lat" ? "ћирилица" : "latinica"}</div>
      </header>
      <div className="top-banner-wrapper">
        <h1 className="top-banner-title">{t("glavniNaslov")}</h1>
      </div>
      <main>
        <section className="left-container">
          <p>{t("pasus1-1")}<b>{t("pasus1-2")}</b>{t("pasus1-3")}</p>
          <h2>{t("podnsalov2")}</h2>
          <p>{t("pasus2")}</p>
          <h2>{t("podnaslov3A")}</h2>
          <p>{t("pasus3A")}</p>
          <h2>{t("podnsalov3")}</h2>
          <p>{t("pasus3")}</p>
          <div className="bluish-wrapper">
            <h2>{t("podnsalov4")}</h2>
            <br />
            <p>{t("pasus4-1")}
              <b>{t("pasus4-2")}</b>
              {/* <br />
              <br />
              {t("pasus4-3")}
              <a href={upitnikDoc} target="_blank" rel="noopener noreferrer">{t("pasus4-4")}</a> */}
            </p>
          </div>
          <div className="documents-container">
            <h2>{t("dokumenta")}</h2>
            <div className="documents-wrapper">
            
              <a href={pozivnoPismo} target="_blank" rel="noopener noreferrer"><HiOutlineDocumentText color="#05295c" size={20} /><p>{t("pozivnoPismo")}</p></a>
              <a href={upitnikDoc} target="_blank" rel="noopener noreferrer"><HiOutlineDocumentText color="#05295c" size={20} /><p>{t("upitnikZaPrivrednaDrustva")}</p></a>
              <a href={rokoviDoc} target="_blank" rel="noopener noreferrer"><HiOutlineDocumentText color="#05295c" size={20} /><p>{t("rokovi2022")}</p></a>
              <a href={smerniceDoc} target="_blank" rel="noopener noreferrer"><HiOutlineDocumentText color="#05295c" size={20} /><p>{t("smerniceZaPripremuDOPprojekata")}</p></a>
              <a href={metodologijaDoc} target="_blank" rel="noopener noreferrer"><HiOutlineDocumentText color="#05295c" size={20} /><p>{t("metodologija")}</p></a>
              <a href={pravilnikOdodeliDoc} target="_blank" rel="noopener noreferrer"><HiOutlineDocumentText color="#05295c" size={20} /><p>{t("pravilnikOdodeli")}</p></a>
              <a href={primeriDobrePrakseDoc} target="_blank" rel="noopener noreferrer"><HiOutlineDocumentText color="#05295c" size={20} /><p>{t("primeriDobrePrakse")}</p></a>
              
            </div>
          </div>
        </section>
        <section className="right-container">
          <div className="form-item-wrapper">
            <label htmlFor="nazivKompanije" className={validationErrors.company ? "error-msg-checkbox" : ""}>{t("nazivKompanije")}*</label>
            <input id="nazivKompanije" type="text"
              value={company}
              onChange={(e) => setCompany(e.currentTarget.value)} />
            <p className="regular-txt error-msg-checkbox">{validationErrors.company ? `${t("obaveznoPolje")}` : ""}</p>
          </div>
          <div className="form-item-wrapper">
            <label htmlFor="maticniBroj" className={validationErrors.mb ? "error-msg-checkbox" : ""}>{t("maticniBroj")}*</label>
            <input id="maticniBroj" type="text"
              value={mb}
              onChange={(e) => setMb(e.currentTarget.value)} />
            <p className="regular-txt error-msg-checkbox">{validationErrors.mb ? `${t("obaveznoPolje")}` : ""}</p>

          </div>
          <div className="form-item-wrapper">
            <label htmlFor="kontaktOsoba" className={validationErrors.contact_person ? "error-msg-checkbox" : ""}>{t("kontaktOsoba")}*</label>
            <input id="kontaktOsoba" type="text"
              value={contact_person}
              onChange={(e) => setContact_person(e.currentTarget.value)} />
            <p className="regular-txt error-msg-checkbox">{validationErrors.contact_person ? `${t("obaveznoPolje")}` : ""}</p>

          </div>
          <div className="form-item-wrapper">
            <label htmlFor="pozicija" className={validationErrors.contact_person_position ? "error-msg-checkbox" : ""}>{t("pozicijaUkompaniji")}*</label>
            <input id="pozicija" type="text"
              value={contact_person_position}
              onChange={(e) => setContact_person_position(e.currentTarget.value)} />
            <p className="regular-txt error-msg-checkbox">{validationErrors.contact_person_position ? `${t("obaveznoPolje")}` : ""}</p>

          </div>
          <div className="form-item-wrapper">
            <label htmlFor="email" className={validationErrors.email ? "error-msg-checkbox" : ""}>{t("email")}*</label>
            <input id="email" type="email"
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)} />
            <p className="regular-txt error-msg-checkbox">{validationErrors.email ? `${t("obaveznoPolje")}` : ""}</p>

          </div>
          <div className="form-item-wrapper">
            <label htmlFor="telefon" className={validationErrors.phone ? "error-msg-checkbox" : ""}>{t("telefon")}*</label>
            <input id="telefon" type="tel"
              value={phone}
              onChange={(e) => setPhone(e.currentTarget.value)} />
            <p className="regular-txt error-msg-checkbox">{validationErrors.phone ? `${t("obaveznoPolje")}` : ""}</p>

          </div>
          <div className="form-item-wrapper">
            <label htmlFor="upitnik" className={validationErrors.questionare ? "error-msg-checkbox" : ""}>{t("upitnikTekst")}* <a href={upitnikDoc} target="_blank" rel="noopener noreferrer">{t("upitnik")}</a></label>
            <input className="fajl-input" type="file" id="upitnik"
              onChange={(e) => checkUpitnikSize(e.currentTarget.files[0])} />
            <p className="regular-txt error-msg-checkbox">{validationErrors.questionare ? `${t("obaveznoPolje")}` : ""}</p>

          </div>
          <div className="form-item-wrapper">
            <label htmlFor="upitnik">{t("ostalaDokumenta1")}<br />{t("ostalaDokumenta2")}</label>
            <input className="fajl-input" type="file" id="upitnik"
              onChange={(e) => checkOstalaDokumentaOgranicenja(e.currentTarget.files)}
              multiple />
          </div>
          <div className="agree-box-wrapper"
            onClick={() => { setIsAgreed1(!isAgreed1) }}>
            <input className="agree-box"
              type="checkbox"
              name="saglasnost-autorksa-prava"
              checked={isAgreed1}
            />
            <label className="agree-label" htmlFor="saglasnost-autorksa-prava">{t("saglasnost1")}</label>
          </div>
          <p className="regular-txt error-msg-checkbox">{isAgreed1Error ? `${t("obaveznoPolje")}` : ""}</p>
          <div className="agree-box-wrapper"
            onClick={() => { setIsAgreed2(!isAgreed2) }}>
            <input className="agree-box"
              type="checkbox"
              name="saglasnost-autorksa-prava"
              checked={isAgreed2}
            />
            <label className="agree-label" htmlFor="saglasnost-autorksa-prava">{t("saglasnost2")}</label>
          </div>
          <p className="regular-txt error-msg-checkbox">{isAgreed2Error ? `${t("obaveznoPolje")}` : ""}</p>
          <button onClick={() => { isSendingInProgres ? console.log("") : checkSendingForm() }}>
            {!isSendingInProgres &&
              <span>
                {t("posalji")}
              </span>
            }
            {isSendingInProgres &&
              <span>
                {t("slanjeUtoku")}
              </span>
            }
          </button>
        </section>
      </main>
      <footer>
        <a className="logo-link" href="https://pks.rs/" target="_blank" rel="noopener noreferrer">
          {i18n.language === "lat" &&
            <img src={pksFooterLogo} alt="logo" />
          }
          {i18n.language === "cyr" &&
            <img src={pksFooterLogoCyr} alt="logo" />
          }

        </a>
        <div className="contact-cards-outer-wrapper">


          <div className="contact-card-container">
            {/* <img className="sanja-bunic-photo" src="https://api.pks.rs/storage/assets/0N1A3543. - Copy (2).jpg" alt="profile" /> */}
            <h3 className="card-title">{t("sanjaBunic")}</h3>
            <div className="card-item-wrapper">
              <p className="card-subtitle">{t("sanjaBunicTitle")}</p>
            </div>
            {/* <div className="card-multi-items-wrapper"> */}
              <a className="card-item-wrapper" href="tel:+381113300939">
                <HiPhoneOutgoing color={"#fff"} size={24} />
                <p className="card-subtitle-link">+381 11 3300 939</p>
              </a>
              <a className="card-item-wrapper" href="tel:+381668751166">
                <BsPhone color={"#fff"} size={24} />
                <p className="card-subtitle-link">+381 66 875 1166</p>
              </a>
            {/* </div> */}
            <a className="card-item-wrapper" href="mailto:csr@pks.rs">
              <HiMail color={"#fff"} size={24} />
              <p className="card-subtitle-link">csr@pks.rs</p>
            </a>

          </div>
          <div className="contact-card-container">
            {/* <img className="milena-milisavljevic-photo" src="https://api.pks.rs/storage/assets/milena.milisavljevic1.jpg" alt="profile" /> */}
            <h3 className="card-title">{t("milenaMilisavljevic")}</h3>
            <div className="card-item-wrapper">
              <p className="card-subtitle">{t("milenaMilisavljevicTitle")}</p>
            </div>
            <a className="card-item-wrapper" href="tel:+381114149608">
              <HiPhoneOutgoing color={"#fff"} size={24} />
              <p className="card-subtitle-link">+381 11 414 9608</p>
            </a>
            <a className="card-item-wrapper" href="mailto:csr@pks.rs">
              <HiMail color={"#fff"} size={24} />
              <p className="card-subtitle-link">csr@pks.rs</p>
            </a>
          </div>
        </div>

        <a className="zastita-link" href="https://pks.rs/zastita-podataka" target="_blank" rel="noopener noreferrer">
          {t("zastitaPodataka")}
        </a>
      </footer>

      {isSentSuccessful &&
        <div className="sent-success-container">
          <p className="sent-succes-title">{t("succes1")}</p>
          <p className="sent-succes-title">{t("succes2")}<a href="mailto:csr@pks.rs"><b>csr@pks.rs</b></a></p>

          <a className="sent-succes-title sent-back-button" href="https://pks.rs/">{t("succesBtn")}</a>
        </div>
      }
    </>
  );
}

export default App;
